import React, { useEffect } from "react"
import { useDispatch } from "react-redux"
import { Loader } from "dash-styled"

import { getStatisticsSnapshot } from "../../../../../../Actions/API/Statistics/StatisticsActions"
import { useStatisticsSnapshot } from "../../../../../../Hooks/useStatisticsSnapshot"
import { AppDetailBase } from "../AppDetailBase/AppDetailBase"

interface OverviewProps {
    orgUsername: string
    appID: string
}

export const Overview: React.FC<OverviewProps> = ({ orgUsername, appID }) => {
    const dispatch = useDispatch()
    const { url } = useStatisticsSnapshot(appID)

    useEffect(() => {
        dispatch(getStatisticsSnapshot(appID))
    }, [appID, dispatch])

    return (
        <AppDetailBase
            orgUsername={orgUsername}
            id={appID}
            title={
                <div className="flex justify-between items-center">
                    <span className="flx-grow">Statistics</span>
                </div>
            }
            breadcrumbs={[]}
            fixedContentWidth={false}
        >
            {url === undefined && <Loader />}
            {url && (
                <iframe
                    title="statistics plots"
                    width="100%"
                    height="100%"
                    src={url}
                />
            )}
        </AppDetailBase>
    )
}
